// extracted by mini-css-extract-plugin
export default {"cjPartnerFloat":"index__cjPartnerFloat___2snPx","cjpdPageEnterNext":"index__cjpdPageEnterNext___1O0dI","cjpdPageEnterPrev":"index__cjpdPageEnterPrev___12jza"};